<template>
  <div class="animated revealUp">
    
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title mb-3">{{ $t('edit') }} {{ $t('concessionstock') }}</div>
      <router-link
        class="btn-blue"
        to="concession-stock"
      >{{ $t('concessionstock') }} {{ $tc('list', 2) }}</router-link>
    </div>
    <div class="edit-movie-container">
      <div class="row">
        <!-- CINEMAS SELECTION -->
        <div class="col-md-6 mb-4">
          <div class="dropdown-curve-container">
            <label :class="selectedCinema.length > 0 ? 'shift-up' : '' ">{{ $tc('cinema', 1) }}</label>
            <div class="d-flex justify-content-center align-items-center">
              <b-dropdown
                :disabled="isRoleID"
                :text="selectedCinema"
                variant="dropdown-curve"
                class="w-100"
              >
                <b-dropdown-item
                  v-for="(cinema,cinemaIndex) in cinemas"
                  :key="cinemaIndex"
                  href="#"
                  @click="onSelectCinema(cinema)"
                >{{ cinema.cine_name }}</b-dropdown-item>
              </b-dropdown>
            </div>
            <p class="error_message">
              <span v-if="submitted && selectedCinema.length == 0">{{ errmsg1 }}</span>
            </p>
          </div>
        </div>

        <!-- SELECTED CONCESSION -->
        <div class="col-md-6 mb-4">
          <div class="dropdown-curve-container">
            <label :class="selectedConcession.length > 0 ? 'shift-up' : '' ">{{ $t('concession') }}</label>
            <div class="d-flex justify-content-center align-items-center">
              <b-dropdown :text="selectedConcession" variant="dropdown-curve" class="w-100">
                <b-dropdown-item
                  v-for="(Item,ItemIndex) in concessionLevels"
                  :key="ItemIndex"
                  href="#"
                  @click="onSelectConcessionLevel(Item)"
                >{{ Item.cl_name }}</b-dropdown-item>
              </b-dropdown>
            </div>
            <p class="error_message">
              <span v-if="submitted && selectedConcession.length == 0">{{ errmsg2 }}</span>
            </p>
          </div>
        </div>

        <div class="col-md-6 mb-4">
          <div class="dropdown-curve-container">
            <label
              :class="selectedRawMaterial.length > 0 ? 'shift-up' : '' "
            >{{ $tc('rawmaterials', 2) }}</label>
            <div class="d-flex justify-content-center align-items-center">
              <b-dropdown :text="selectedRawMaterial" variant="dropdown-curve" class="w-100">
                <b-dropdown-item
                  v-for="(Item,ItemIndex) in cinemas_stock"
                  :key="ItemIndex"
                  href="#"
                  @click="onSelectRawMaterial(Item)"
                >{{ Item.rm_name }}</b-dropdown-item>
              </b-dropdown>
            </div>
            <p class="error_message">
              <span v-if="submitted && selectedRawMaterial.length == 0">{{ errmsg5 }}</span>
            </p>
          </div>
        </div>

        <div class="col-md-6 mb-4">
          <div class="dropdown-curve-container">
            <label
              :class="selectedUoM.length > 0 ? 'shift-up' : '' "
            >{{ $tc('unitofmeasurement', 2) }}</label>
            <div class="d-flex justify-content-center align-items-center">
              <b-dropdown :text="selectedUoM" variant="dropdown-curve" class="w-100">
                <b-dropdown-item
                  v-for="(Item,ItemIndex) in cinemas_stock"
                  :key="ItemIndex"
                  href="#"
                  @click="onSelectUom(Item)"
                >{{ Item.uom_unit }}</b-dropdown-item>
              </b-dropdown>
            </div>
            <p class="error_message">
              <span v-if="submitted && selectedUoM.length == 0">{{ errmsg4 }}</span>
            </p>
          </div>
        </div>

        <div class="col-md-6 mb-4">
          <div class="dropdown-curve-container">
            <label :class="selectedQuantity.length > 0 ? 'shift-up' : '' ">{{ $tc('quantity', 2) }}</label>
            <div class="d-flex justify-content-center align-items-center">
              <b-dropdown :text="selectedQuantity" variant="dropdown-curve" class="w-100">
                <b-dropdown-item
                  v-for="(Item,ItemIndex) in Quantity"
                  :key="ItemIndex"
                  href="#"
                  @click="selectedQuantity = Item;concession_stock.stock_quantity =Item"
                >{{ Item }}</b-dropdown-item>
              </b-dropdown>
            </div>
            <p class="error_message">
              <span v-if="submitted && selectedQuantity.length == 0">{{ errmsg3 }}</span>
            </p>
          </div>
        </div>

        <div class="col-md-12 text-center mt-4">
          <button @click.prevent.stop="onFinalSubmit()" class="btn-blue">{{ $t('update') }}</button>
          <button v-on:click="onResetForm()" class="btn-black">{{ $t('reset') }}</button>
          <b-button
            class="btn-outline-grey"
            variant="default"
            to="concession-stock"
          >{{ $t('cancel') }}</b-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PosFnbService from "@/services/PosFnbService.js";
import MasterService from "@/services/MasterService.js";

export default {
  data() {
    return {
      isRoleID: true,
      submitted: false,
      errmsg1: "",
      errmsg2: "",
      errmsg3: "",
      errmsg4: "",
      errmsg5: "",
      concession_stock: {
        cinema_id: "",
        stock_id: "",
        cld_level_id: "",
        rm_id: "",
        stock_quantity: "",
        uom_id: "",
        cstock_id: null
      },
      cinemas: [],
      concessionLevels: [],
      cinemas_stock: [],
      Quantity: 0,
      selectedCinema: "",
      selectedConcession: "",
      selectedRawMaterial: "",
      selectedQuantity: "",
      selectedUoM: ""
    };
  },
  beforeMount() {
    let obj = this.secureStore.get("USINFO").cinema_id;
    let roleid = this.secureStore.get("USINFO").role_id;
    if (true) {
      this.isRoleID = false;
    }

    this.concession_stock.cstock_id = this.$route.query.cstock_id;
  },
  mounted() {
    this.getConcessionStockDetails();
    // this.getCinemas();
  },
  methods: {
    getConcessionStockDetails: function() {
      let payload = {
        cstock_id: this.concession_stock.cstock_id
      };
      PosFnbService.GetConcessionStock(payload)
        .then(response => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            let obj = data.Records[0];
            this.concession_stock = obj;
            this.Quantity = obj.stock_quantity;
            this.concession_stock.cinema_id = obj.main_cinema_id;
            this.selectedQuantity = String(obj.stock_quantity);
            this.selectedRawMaterial = obj.rm_name;
            this.selectedUoM = obj.uom_unit;
            this.getCinemas(obj.main_cinema_id);
            this.getConcessionLevels(obj.main_cinema_id, obj.cld_level_id);
            // this.getCinemasStocks(obj);
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(error => {
          this.$toasted.show(error);
        });
    },
    getCinemas: function(cinema_id) {
      let payload = {
        tableName: "ms_cinemas"
      };
      MasterService.GetActiveList(payload)
        .then(response => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.cinemas = data.Records;
            this.cinemas.map(x => {
              if (x.cine_id == cinema_id) {
                this.selectedCinema = x.cine_name;
              }
            });
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(error => {
          this.$toasted.show(error);
        });
    },
    getConcessionLevels: function(cinema_id, cld_level_id) {
      this.concessionLevels = [];
      this.selectedConcession = "Select Concession";
      let payload = {
        tableName: "ms_concession_levels",
        cl_is_active: "Y",
        cinema_id: cinema_id
      };
      MasterService.GetActiveList(payload)
        .then(response => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.concessionLevels = data.Records;
            console.log("cld_level_id :", cld_level_id);
            console.log("this.concessionLevels :", this.concessionLevels);
            this.concessionLevels.push(x => {
              console.log("cld_level_id+_+_", x.cl_id);
              if (x.cl_id == cld_level_id) {
                this.selectedConcession = x.cl_name;
              }
            });
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(error => {
          this.$toasted.show(error);
        });
    },
    onSelectCinema: function(cinema) {
      this.selectedCinema = cinema.cine_name;
      this.concession_stock.cinema_id = cinema.cine_id;
      this.getConcessionLevels(cinema.cine_id);
      this.getCinemasStocks(cinema.cine_id);
    },
    // getCinemasStocks: function(obj) {
    //   this.cinemas_stock = [];
    //   let payload = {
    //     cinema_id: obj.main_cinema_id
    //   };
    //   PosFnbService.GetCinemaStocks(payload)
    //     .then(response => {
    //       const { data } = response;
    //       if (data && data.status && data.Records.length > 0) {
    //         this.cinemas_stock = data.Records;
    //         this.cinemas_stock.map(x => {
    //           if (x.rm_id == obj.rm_id) {
    //             this.selectedRawMaterial = x.rm_name;
    //           }
    //           if (x.uom_id == obj.uom_id) {
    //             this.selectedUoM = x.uom_unit;
    //           }
    //           // if(x.stock_quantity == obj.stock_quantity){
    //           //   this.
    //           // }
    //         });
    //       } else {
    //         this.$toasted.show(data.message);
    //       }
    //     })
    //     .catch(error => {
    //       this.$toasted.show(error);
    //     });
    // },

    onSelectConcessionLevel: function(concession) {
      this.selectedConcession = concession.cl_name;
      this.concession_stock.cld_level_id = concession.cl_id;
    },

    onSelectRawMaterial: function(rawmaterial) {
      this.selectedRawMaterial = rawmaterial.rm_name;
      this.concession_stock.rm_id = rawmaterial.rm_id;
      this.Quantity = rawmaterial.stock_quantity;
      this.concession_stock.stock_id = rawmaterial.stock_id;
    },

    onSelectUom: function(uom) {
      this.selectedUoM = uom.uom_unit;
      this.concession_stock.uom_id = uom.uom_id;
    },

    onResetForm: function() {
      this.concession_stock = {
        cinema_id: "",
        stock_id: "",
        cld_level_id: "",
        rm_id: "",
        stock_quantity: "",
        uom_id: ""
      };
      this.selectedCinema = "Select Cinema";
      this.selectedConcession = "Select Concession";
      this.selectedQuantity = "Select Quantity";
      this.selectedUoM = "Select Uom";
    },
    onFinalSubmit: function() {
      this.submitted = true;
      if (this.selectedCinema == "Select Cinema") {
        this.errmsg1 = "Please Select Cinema.";
      }
      if (this.selectedConcession == "Select Concession") {
        this.errmsg2 = "Please Select Concession.";
      }
      if (this.selectedQuantity == "Select Quantity") {
        this.errmsg3 = "Please Select Quantity.";
      }
      if (this.selectedUoM == "Select UoM") {
        this.errmsg4 = "Please Select UoM.";
      }
      if (this.selectedRawMaterial == "Select Raw Material") {
        this.errmsg5 = "Please Select Raw Material.";
      } else {
        this.$validator.validate().then(valid => {
          console.log("valid :", valid);
          if (valid) {
            let payload = {
              ...this.concession_stock
            };
            PosFnbService.UpdateConcessionStock(payload)
              .then(response => {
                const { data } = response;
                if (data && data.status) {
                  this.onResetForm();
                  this.$router.push({
                    path: "/fnb/concession-stock"
                  });
                } else {
                  this.$toasted.show(data.message);
                }
              })
              .catch(this._CatchError); //message
          }
        });
      }
    }
  }
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/Pages/FoodAndBeveragesContainer/ConcessionStockComponents/editConcessionStock.vue